import { DEFAULT_BASE_SIZE } from '@sr/templates/src';
import { Resume } from '@sr/types';
import React, { useState } from 'react';
import {
  CrossIcon,
  DesignIcon,
  ContentWithSidebar,
  Box,
  TUILink,
} from '../../ui';
import ResumePreviewContainer from './ResumePreviewContainer';
import Sidebar from './Sidebar';

const Preview = ({
  resume,
  isVisible,
}: {
  resume: Resume;
  isVisible: boolean;
}) => {
  const [localBaseSize, setLocalBaseSize] = useState(
    getInitialBaseSize(resume)
  );

  if (!isVisible) return null;

  return (
    <ContentWithSidebar
      openButtonContents={<OpenButtonContents />}
      closeButtonContents={<CrossIcon color="white" />}
      sidebarContent={
        <Sidebar
          resume={resume}
          setLocalBaseSize={setLocalBaseSize}
          localBaseSize={localBaseSize}
        />
      }
      mainContent={
        <ResumePreviewContainer resume={resume} localBaseSize={localBaseSize} />
      }
      rightSidebarContent={<RightSidebar />}
      isDark={true}
    />
  );
};

const OpenButtonContents = () => (
  <>
    <DesignIcon pr={2} color="white" /> Design
  </>
);

function getInitialBaseSize(resume: Resume): number {
  return (
    resume.style.customizations[resume.style.activeTemplateId]?.baseSize ||
    DEFAULT_BASE_SIZE
  );
}

function RightSidebar() {
  const blueText = {
    backgroundColor: 'blue',
    color: 'white',
    lineHeight: 1,
    fontWeight: 'bold',
    fontSize: 28,
    px: 1,
  };
  const linkStyle = {
    color: 'blueDark',
    textDecoration: 'none',
    marginTop: 2,
    ':hover': { textDecoration: 'underline' },
  };
  return (
    <div>
      <Box
        sx={{
          marginTop: 32,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          bg: 'rgba(255, 255, 255, 0)',
          border: '1px solid rgba(255, 255, 255, 0.5)',
          padding: '14px 12px 16px 14px',
        }}
      >
        <Box sx={blueText}>The</Box>
        <Box sx={blueText}>Resume</Box>
        <Box sx={blueText}>Handbook</Box>
        <Box
          sx={{ fontSize: 14, lineHeight: 1.5, mt: 3, mb: 2, color: 'white70' }}
        >
          Wisdom from 8 years of helping over 200,000 people create a winning
          resume, combined with insights from top recruiters and hiring
          managers.
        </Box>
        <TUILink
          href="https://learn.standardresume.co/design/photos"
          target="_blank"
          sx={linkStyle}
        >
          When to Include a Photo →
        </TUILink>
        <TUILink
          href="https://learn.standardresume.co/design/visual-design"
          target="_blank"
          sx={linkStyle}
        >
          Visual Design Tips →
        </TUILink>
        <TUILink
          href="https://learn.standardresume.co/design/layout"
          target="_blank"
          sx={linkStyle}
        >
          Resume Layouts →
        </TUILink>
        <TUILink
          href="https://learn.standardresume.co"
          target="_blank"
          sx={linkStyle}
        >
          Overview →
        </TUILink>
      </Box>
    </div>
  );
}

export default Preview;
